
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment communiquer efficacement quand on est une TPE",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            " Avoir une stratégie de communication efficace est aujourd’hui devenuessentiel lors du lancement d’une nouvelle activité professionnelle ou de son développement.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment communiquer efficacement quand on est une TPE",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Avoir une stratégie de communication efficace est aujourd’hui devenu essentiel lors du lancement d’une nouvelle activité professionnelle ou de son développement.",
        },
      ],
    };
  },
};
